import React from "react"
import { Button, Dropdown, Tag, Flex, Typography } from "antd"
import { MoreOutlined, PlusOutlined } from "@ant-design/icons"
import AddOnPhoto from "ui/AddOnPhoto"
import styles from "./columns.module.css"

const { Text } = Typography


export const getColumns = (getMenuItems, isMutating, t, onOpenAssignExperiences) => [
  {
    title: t("settings.column_title"),
    dataIndex: "title",
    key: "title",
    width: 220,
    render: (value, record) => (
      <Flex align="center" gap={8} className={styles.titleCell}>
        <AddOnPhoto src={record.photo_url} alt={value} size={32} iconSize={16} />
        <span className={styles.titleText}>{value}</span>
      </Flex>
    )
  },
  {
    title: t("settings.add_ons.column_category", { defaultValue: "Category" }),
    dataIndex: ["add_on_category", "name"],
    key: "category",
    width: 160,
    render: (_v, record) => record.add_on_category?.name ?? "—"
  },
  {
    title: t("settings.column_price"),
    dataIndex: "price",
    key: "price",
    width: 120,
    render: (value) => `$${Number(value)?.toFixed(2)}`
  },
  {
    title: t("settings.add_ons.column_min_max", { defaultValue: "Min / Max" }),
    key: "min_max",
    width: 140,
    render: (_v, record) => {
      const min = record.min_per_order
      const max = record.max_per_order
      if (min == null && max == null) return "—"
      return `${min ?? 0} / ${max ?? "∞"}`
    }
  },
  {
    title: t("settings.add_ons.column_experiences", { defaultValue: "Experiences" }),
    dataIndex: "associated_trips",
    key: "experiences",
    width: 180,
    render: (trips, record) => {
      const count = record.associated_trips_count ?? trips?.length ?? 0
      const handleClick = (e) => {
        e.stopPropagation()
        onOpenAssignExperiences?.(record)
      }
      if (!count) {
        // Empty state — render as a primary action link with a plus icon.
        return (
          <Button type="link" icon={<PlusOutlined />} style={{ padding: 0, height: "auto" }} onClick={handleClick}>
            {t("settings.add_ons.assign_experiences", { defaultValue: "Assign experiences" })}
          </Button>
        )
      }
      // Assigned — render the name(s) as plain (clickable) text.
      const first = trips?.[0]
      return (
        <Text style={{ cursor: "pointer" }} onClick={handleClick}>
          {first?.title ?? `${count} experiences`}
          {count > 1 && <Text type="secondary"> +{count - 1}</Text>}
        </Text>
      )
    }
  },
  {
    title: t("settings.column_status"),
    dataIndex: "enabled",
    key: "status",
    width: 110,
    render: (status) =>
      status ? (
        <Tag color="success">{t("settings.status_active")}</Tag>
      ) : (
        <Tag color="default">{t("settings.status_inactive")}</Tag>
      )
  },
  {
    title: "",
    key: "actions",
    align: "right",
    width: 60,
    render: (_, record) => (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown menu={{ items: getMenuItems(record) }} trigger={["click"]} placement="bottomRight" disabled={isMutating}>
          <Button type="text" icon={<MoreOutlined />} />
        </Dropdown>
      </div>
    )
  }
]
